export default __webpack_public_path__ + "static/media/boundretro.8e6fce44.png";